/**
 * Hand-off channel for "Start Chat" from the Clipboard page.
 *
 * "Start chat with selection" opens the chat in a *new tab*, so the hand-off
 * uses localStorage (shared across same-origin tabs), not sessionStorage
 * (per-tab). Clipboard writes the selection, opens /chat in a new tab, and the
 * chat composer there consumes it exactly once on mount.
 */

export type PendingChatAttachment = {
  kind: "file" | "folder";
  /** Full VFS path, e.g. "/clipboard/oa/usr_ab12cd34ef56" or "/clipboard/oa/". */
  path: string;
  /** Display name (filename or folder name). */
  name: string;
};

const KEY = "paperclip.pendingChatAttachments";

export function setPendingChatAttachments(items: PendingChatAttachment[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(items));
  } catch {
    /* localStorage unavailable (private mode / SSR) — non-fatal */
  }
}

/** Read and clear the pending attachments (consume-once, cross-tab). */
export function consumePendingChatAttachments(): PendingChatAttachment[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    localStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as PendingChatAttachment[]) : [];
  } catch {
    return [];
  }
}
